import apiFetch from '../apiFetch'
export default function (entityTypeId, parentId, token) {
  return apiFetch({ endPoint: `entity/FilterByTypeByParent?entityTypeId=${entityTypeId}&parentId=${parentId}`, method: 'GET', body: null, token: token })
}
